/*
 * Javascript for the header page
*/
(function($) {

	const screen_xs = window.screen_xs || 480;
	const screen_sm = window.screen_sm || 768;
	const screen_md = window.screen_md || 992;

	const mediaQuery = window.matchMedia('(max-width: '+screen_md+'px)')
	if (mediaQuery.matches) {
		$('.parent').removeClass('sel');
	}

	//Big nav
	$(window).on('resize', function(){
		const mediaQuery = window.matchMedia('(min-width: '+screen_sm+'px)')
		// Check if the media query is true
		if (mediaQuery.matches) {
			var timer, current_hover;
			$('.secondary nav ul li.has-big-menu').unbind('click');
			$('.secondary nav ul li.has-big-menu').on('mouseover touchend', function(e) {
				if((e.type == 'touchend') && ($(e.target).is('a.parent.sel'))) {
					e.stopImmediatePropagation();
					e.preventDefault();
					if($(this).hasClass('open-menu')) {
						$(this).removeClass('open-menu');
						//$('.parent').removeClass('sel');
						$('body').removeClass('nav-hover');
					} else {
						$(this).addClass('open-menu');
						$('body').addClass('nav-hover');
					}
					return false;
				} else if((e.type == 'touchend') && ($(e.target).is('a.parent'))) {
					e.stopImmediatePropagation();
					e.preventDefault();
					$('.parent').removeClass('sel');
					$(this).find('.parent').addClass('sel');
				}

				current_hover = $(this);
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('.nav-big-menu').addClass('hidden sm:hidden');
					current_hover.find('.nav-big-menu').removeClass('hidden sm:hidden');
					$('body').addClass('nav-hover');
				}, 200);
			}).on("mouseleave", function() {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('.nav-big-menu').addClass('hidden sm:hidden');
					$('body').removeClass('nav-hover');
				}, 300);
			});
		} else {
			//MOBILE
			clearTimeout(timer);
			$('.secondary nav ul li.has-big-menu:not(.gc)').unbind('mouseover mouseleave');
			$('.secondary nav ul li.has-big-menu:not(.gc) a.parent').on('click', function(e) {
				e.stopImmediatePropagation();
				e.preventDefault();
				var menu = $(this).parent().find('.nav-big-menu');
				$(this).parent().find('.mob-nav-icon svg').toggleClass('hidden');
				if(!menu.hasClass('hidden')) {
					$('.nav-big-menu').addClass('hidden');
				} else {
					console.log('new click');
					$('.nav-big-menu').addClass('hidden');
					menu.removeClass('hidden');
				}
				return false;
			});
		}
	});
	$(window).trigger('resize');

	$(document).on('click', 'body.nav-hover #main', function(e) {
		//Only for touch screens when nav-hover shows, close on touch
		//Put this outside media queries because it overlaps
		$('.secondary nav ul li').removeClass('open-menu');
		$('body').removeClass('nav-hover');
	});

	$('.mob-menu').on('click', function() {
		//$(this).toggleClass('is-active');
		//$('.main-nav').toggleClass('is-active');
		$('.secondary').toggleClass('hidden');
		$('.search-col').addClass('hidden');
		$('.mob-menu svg').toggleClass('hidden');
	});
	$('.mob-search').on('click', function() {
		$('.search-col').toggleClass('hidden');
		if(!$('.search-col').hasClass('hidden')) {
			$('.head-search').trigger('focus');
		}
	});

	//$('.featured .featured-col').matchHeight();


	document.addEventListener('lazyloaded', function(e){
		if(e.target.getAttribute('data-location') == 'header') {
			//$('.featured .featured-col').matchHeight();
		}
	});

	//Search autocomplete
	/*var searches = new Bloodhound({
		datumTokenizer: Bloodhound.tokenizers.ngram,
		queryTokenizer: Bloodhound.tokenizers.ngram,
		remote: {
			url: '/api/search?q=%QUERY',
			wildcard: '%QUERY',
			filter: function (response) {
				return response.data;
			}
		}
	});
	$('.head-search').typeahead({
		highlight: true
	}, {
		name: 'head-search',
		limit: 10,
		source: searches,
		templates: {
			suggestion: function(data){
				return '<p><a href="' + data.url + '">' + data.title + '</a></p>';
			}
		},
		displayKey: 'title'
	}).on('typeahead:asyncrequest', function() {
		showLoadingBar();
		$('.search-col button').addClass('searching');
	}).on('typeahead:asynccancel typeahead:asyncreceive', function() {
		removeLoadingBar();
		$('.search-col button').removeClass('searching');
	}).on('typeahead:selected', function(event, selection) {
		showLoadingBar();
		window.location.href = selection.url;
	});;*/

	//If logged in
})(jQuery);

function profileDropdownBtn() {
	const btn = document.querySelector(".profile-dropdown-btn");
	const dropdown = document.querySelector(".profile-dropdown");
	
	if (!btn || !dropdown) return;
	
	// Remove existing listeners to avoid duplicates
	btn.removeEventListener("click", toggleDropdown);
	document.removeEventListener("click", closeDropdown);
	
	function toggleDropdown(e) {
		e.preventDefault();
		e.stopPropagation();
		dropdown.classList.toggle("hidden");
	}
	
	function closeDropdown(e) {
		if (!btn.contains(e.target) && !dropdown.contains(e.target)) {
			dropdown.classList.add("hidden");
		}
	}
	
	btn.addEventListener("click", toggleDropdown);
	document.addEventListener("click", closeDropdown);
}

profileDropdownBtn();
htmx.on("htmx:afterSwap", function (event) {
	console.log("HTMX content swapped");
	profileDropdownBtn();
});